import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { authRoles } from 'app/auth';
import SupportDashboardLayout from './layouts/SupportDashboardLayout';

const LinkageRequestsTab = lazy(() => import('./use-cases/linkage-requests'));
const AllUsersTab = lazy(() => import('./use-cases/all-users'));
const EmailLogTab = lazy(() => import('./use-cases/email-log'));

const SupportDashboardConfig = {
  settings: {
    layout: {
      config: {
        footer: { display: false },
        healtheraHeader: { display: true },
      },
    },
  },
  auth: authRoles.support,
  routes: [
    {
      path: 'support-dashboard',
      element: <SupportDashboardLayout />,
      children: [
        { path: '', element: <Navigate to="linkage-requests" replace /> },
        { path: 'linkage-requests', element: <LinkageRequestsTab /> },
        { path: 'users', element: <AllUsersTab /> },
        { path: 'email-log', element: <EmailLogTab /> },
        { path: '*', element: <Navigate to="linkage-requests" replace /> },
      ],
    },
  ],
};

export default SupportDashboardConfig;
